/** Entrada curta usada nas trocas de página, abas e blocos de alerta. */
export const pageMotion = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
  transition: { duration: 0.32, ease: [0.4, 0, 0.2, 1] },
};

export function motionWithDelay(delay = 0) {
  return {
    initial: pageMotion.initial,
    animate: pageMotion.animate,
    exit: pageMotion.exit,
    transition: { ...pageMotion.transition, delay },
  };
}
